import React, { useEffect, useState } from 'react'
import Hero from '../components/landing/Hero'
import Expertise from '../components/landing/Expertise'
import Portfolio from '../components/landing/Portfolio'
import Clients from '../components/landing/Clients'
import WhyUs from '../components/landing/WhyUs'
import OurJourney from '../components/landing/OurJourney'


const Landing = () => {

  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])

  return (
    <div className='h-fit w-[100vw] lg:w-full overflow-x-hidden' >
      
      <Hero />
      <Expertise />
      <Portfolio />
      <Clients />
      <WhyUs />
      <OurJourney />
    </div>
  )
}

export default Landing
